import { FETCH_SHARES } from "../../actions/types";

const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_SHARES:
      return {
        ...state,
        items: action.payload
      };

    default:
      return state;
  }
}
